import { render, staticRenderFns } from "./LawSearch.vue?vue&type=template&id=56ba542c&scoped=true"
import script from "./LawSearch.vue?vue&type=script&lang=js"
export * from "./LawSearch.vue?vue&type=script&lang=js"
import style0 from "./LawSearch.vue?vue&type=style&index=0&id=56ba542c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba542c",
  null
  
)

export default component.exports